import SpriteSymbol from "../../../../../../../node_modules/normacs_web/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/normacs_web/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag",
  "use": "flag-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 64 64\" id=\"flag\">\n    <path fill-rule=\"nonzero\" d=\"M26 13.811V44.19a1 1 0 0 0 1.533.846l24.123-15.189a1 1 0 0 0 0-1.692L27.533 12.965a1 1 0 0 0-1.533.846zM18 54V14a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v40a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol